import { BoxArrowUpIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { useUnarchivePackage } from '@/api/packages/unarchive-package'
import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'

import * as S from './unarchive-package-modal.styled'

export interface UnarchivePackageModalProps {
  packageId: number
  onClose: () => void
}

export const UnarchivePackageModal = ({ packageId, onClose }: UnarchivePackageModalProps) => {
  const { t } = useTranslation(['packages'])
  const { mutateAsync: unarchivePackage, isPending } = useUnarchivePackage({ onSuccess: onClose })

  return (
    <ConfirmationPopup
      autoWidth
      variant="info"
      title={t('packages:unarchivePackageModal.title')}
      confirmText={t('packages:unarchivePackageModal.confirm')}
      cancelText={t('packages:unarchivePackageModal.cancel')}
      closeable={!isPending}
      closeOnOverlayClick={!isPending}
      closeOnEscapeKey={!isPending}
      confirmIcon={BoxArrowUpIcon}
      onConfirm={() => unarchivePackage({ id: packageId })}
      onClose={onClose}
    >
      <S.Container>
        <Typography color="black700" size="heading-medium" weight="medium">
          {t('packages:unarchivePackageModal.body')}
        </Typography>
      </S.Container>
    </ConfirmationPopup>
  )
}
